import { mergeMap, map, catchError } from 'rxjs/operators';
import { ofType } from 'redux-observable';

import { SAVE_STACKUP } from '../actions/action-types';
import { saveStackupFulfilled, saveStackupRejected } from '../actions';
import { saveStackup } from '../services/stackup';
import { getStackup } from '../reducers';

export function saveStackupEpic(action$, state$){
  return action$
    .pipe(
      ofType(SAVE_STACKUP),
      mergeMap(() => {
        const stackup = getStackup(state$.value);

        return saveStackup(stackup)
          .pipe(
            map(response => saveStackupFulfilled(response.response)),
            catchError(error => saveStackupRejected(error))
          )
      })
    );
}

export default saveStackupEpic;



// WEBPACK FOOTER //
// ./src/epics/saveStackup.js